import { render, staticRenderFns } from "./IconBurgerMenu.vue?vue&type=template&id=e3c31732"
import script from "./IconBurgerMenu.vue?vue&type=script&lang=js"
export * from "./IconBurgerMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports